const commissionPercent = (commission, price) => {
    const c = Number(commission);
    const p = Number(price);
    if (!p) return 0;
    return Math.round((c / p) * 1000) / 10;
};

export default commissionPercent;
